import MerchSearchBar from '@carvana/merch-search-bar';
import cx from 'classnames';
import dynamic from 'next/dynamic';
import { useContext, useState } from 'react';
import { useIsMobile } from '~/context/common/DeviceContext';
import ModalContext from '~/context/home/ModalContext';
import BackgroundOverlay from './BackgroundOverlay';
import styles from './SearchBar.module.css';
import useSearchBarProps from './useSearchBarProps';

const SearchBarModal = dynamic(
  () => import(/* webpackChunkName: "SearchBarModal" */ './SearchBarMobile'),
  { ssr: false }
);

export default function SearchBar() {
  const { isSearchBarFocused } = useContext(ModalContext);
  const [inputValue, setInputValue] = useState('');
  const searchBarProps = useSearchBarProps();
  const isMobile = useIsMobile();

  return (
    <>
      <BackgroundOverlay />
      <div
        data-testid="home-search-bar"
        className={cx(
          'relative z-30 transition-[width] ease-in-out',
          isSearchBarFocused
            ? 'duration-300 md:w-[944px]'
            : 'duration-100 sm:w-[400px] md:w-[500px]'
        )}
      >
        <MerchSearchBar
          inputValue={inputValue}
          setInputValue={setInputValue}
          {...searchBarProps}
          classes={{
            ...searchBarProps.classes,
            resultsContainer: cx(
              searchBarProps.classes?.resultsContainer,
              styles.dropdown
            )
          }}
        />
      </div>
      {isMobile && (
        <SearchBarModal
          data-testid="home-search-bar-modal"
          inputValue={inputValue}
          setInputValue={setInputValue}
          {...searchBarProps}
        />
      )}
    </>
  );
}
